/* global __webpack_require__ */

/**
 * Recupera falhas no carregamento de chunks (ChunkLoadError).
 *
 * Quando um /_nuxt/*.js é pedido durante a troca de deploy e ainda não existe
 * na Vercel, ela devolve o index.html com `cache-control: immutable` de 1 ano.
 * O Cloudflare e o navegador guardam esse HTML na URL do chunk, e a página fica
 * presa no spinner. Pedir o mesmo arquivo com uma query string nova fura os dois
 * caches. Se ainda falhar (HTML de um deploy antigo pedindo chunk que não existe
 * mais), recarrega a página uma vez para buscar o runtime atual.
 *
 * O patch roda ao avaliar o módulo, antes de `mountApp` carregar a página.
 */

const RETRY_PARAM = 'chunk_retry'
const RETRY_TIMEOUT_MS = 30 * 1000
const RELOAD_KEY = 'unico_chunk_reload_at'
const RELOAD_COOLDOWN_MS = 60 * 1000

function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        const done = () => {
            clearTimeout(timer)
            script.onload = script.onerror = null
            resolve()
        }
        const timer = setTimeout(done, RETRY_TIMEOUT_MS)

        script.charset = 'utf-8'
        script.src = src
        script.onload = script.onerror = done
        document.head.appendChild(script)
    })
}

function reloadOnce() {
    try {
        const lastReload = Number(sessionStorage.getItem(RELOAD_KEY))
        if (lastReload && Date.now() - lastReload < RELOAD_COOLDOWN_MS) {
            return
        }
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
    } catch (e) {
        // sem sessionStorage não há como evitar loop de reload
        return
    }

    window.location.reload()
}

const ensureChunk = __webpack_require__.e

__webpack_require__.e = function ensureChunkWithRetry(chunkId) {
    return ensureChunk(chunkId).catch((error) => {
        if (!error || error.name !== 'ChunkLoadError' || !error.request) {
            throw error
        }

        const separator = error.request.indexOf('?') === -1 ? '?' : '&'
        const retryUrl = `${error.request}${separator}${RETRY_PARAM}=${Date.now()}`

        // Se o script registrou o chunk, ensureChunk resolve sem nova requisição
        return loadScript(retryUrl)
            .then(() => ensureChunk(chunkId))
            .catch((retryError) => {
                reloadOnce()
                throw retryError
            })
    })
}
